/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { containerAnimation } from "config/animation";

/* COMPONENTS */
import Banner from "components/banner";
import CoursesOffered from "components/courses";
import AboutUs from "components/about-us";
import Testimonials from "components/testimonials";
import FrequentlyAskedQuestions from "components/faqs";
import OfficeLocation from "components/location";
import WhyChooseDFA from "components/why-choose-us";

const Homepage = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
    >
      {/* BANNER */}
      <Banner />

      {/* ABOUT US */}
      <AboutUs />

      {/* COURSES OFFERED */}
      <CoursesOffered />

      {/* WHY DREAMFORCE ACADEMY */}
      {/* <WhyDreamforceAcademy /> */}

      {/* TESTIMONIALS */}
      <Testimonials />

      {/* FREQUENTLY ASKED QUESTIONS */}
      <FrequentlyAskedQuestions />

      {/* WHY CHOOSE DFA */}
      <WhyChooseDFA />

      {/* LOCATION */}
      <OfficeLocation />
    </motion.section>
  );
};

export default Homepage;
